import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { hasCap, hasProduct } from "../utils/capabilities";

// Menu hiding is not access control; this is only the friendly redirect for a tenant that does not hold the product
// (a CRA-only tenant opening a bookmarked /edges lands on its own page). The API enforces the real limits.
export default function ProductGate({ product, children }) {
  const me = useSelector((s) => s.session?.me);
  if (!me || hasProduct(me, product)) return children;
  return <Navigate to={hasCap(me, "security.sbom") ? "/machine-sbom" : "/profile"} replace />;
}
